import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class Owner {

  @JsonProperty()
  id: number = -1;

  @JsonProperty()
  code: string | undefined;

  @JsonProperty()
  description: string | undefined;

  @JsonProperty()
  enabled: boolean = true;

  @JsonProperty()
  country: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  ownerRole: Owner.OwnerRole = Owner.OwnerRole.GLOBAL;

  @JsonProperty()
  address: string | undefined;

  @JsonProperty()
  zipCode: string | undefined;

  @JsonProperty()
  town: string | undefined;

  @JsonProperty()
  currentInvoiceNumber: number | undefined;

  @JsonProperty()
  currentCreditNoteNumber: number | undefined;

  @JsonProperty()
  vatRateId: number = 0;

  @JsonProperty()
  vatNumber: string | undefined;

  @JsonProperty()
  lei: string | undefined;

  @JsonProperty()
  invoiceTemplate: string | undefined;


}

export module Owner {
  export enum OwnerRole {
    CUSTOMER = 'CUSTOMER',
    GLOBAL = 'GLOBAL'
  }
}
